import Vue from "vue";
import SurveysListing from "./SurveysListing.vue";

export function load() {
    const selector = "surveys-listing-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
      createElement(SurveysListing, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
